import { useState, useContext, useEffect } from 'react';
import { Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { MenuOutlined, SearchOutlined } from '@ant-design/icons';

import EdenContext from '../../context/edenContext';
import Select from '../select';
import ToolTip from '../tooltip';
import axiosInstance from '../../api/axiosInstance';

import styles from './sidebar.module.scss';

const Sidebar = ({ collapsed, toggleCollapsed, setCollapsed }) => {
	const { userType, userMail, menuItems } = useContext(EdenContext);

	const location = useLocation();
	const navigate = useNavigate();
	const [openKeys, setOpenKeys] = useState([]);

	const [leaveTime, setLeaveTime] = useState(null);

	useEffect(() => {
		setLeaveTime(new Date());
	}, [location.pathname]);

	const rootSubmenuKeys = [
		'/',
		'/sales-performance',
		'/email-engagement',
		'/rfq-opportunities',
		'/my-sources',
		'/my-quotes',
	];

	const onOpenChange = (keys) => {
		const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
		if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
			setOpenKeys(keys);
		} else {
			setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
		}
	};

	const onClick = ({ key }) => {
		navigate(key);
		setCollapsed(true);

		const leDate = new Date(leaveTime?.toISOString());
		const entDate = new Date(new Date().toISOString());
		const diffInMilliseconds = Math.abs(leDate - entDate);
		const url = window.location.pathname;
		const sectionName = url
			?.substring(url?.lastIndexOf('/'))
			.replace(/[/-]/g, ' ')
			.toUpperCase()
			.trim();

		const data = {
			user_email: userMail,
			section_name: sectionName,
			section_enter_time: leaveTime?.toISOString(),
			section_leave_time: new Date().toISOString(),
			total_duration_seconds: diffInMilliseconds / 1000,
			event_datetime: '',
			comment: '',
		};

		axiosInstance
			.post(
				`https://internal.supremecomponents.com/api/track.php`,
				JSON.stringify(data),
			)
			.then((response) => {});
	};

	return (
		<div className={styles['sidebar-wrapper']}>
			<div onClick={toggleCollapsed} className={styles['collapse-btn']}>
				<MenuOutlined />
			</div>
			{collapsed === true ? (
				<div className={styles['search-icon']}>
					<ToolTip title="Search Section" placement="right">
						<SearchOutlined
							onClick={() => {
								setCollapsed(false);
							}}
						/>
					</ToolTip>
				</div>
			) : (
				<div className={styles['search-menu']}>
					<Select
						autoFocus={true}
						type="bordered"
						placeholder="Search"
						optionFilterProp={'label'}
						labelInValue={true}
						style={{ width: userType === 'sm' ? '260px' : '225px', height: 40 }}
						options={menuItems
							.filter((item) => item !== false && item !== null)
							.flatMap((item) =>
								item?.children
									? item.children.map((subItem) => ({
											value: subItem?.key || subItem?.label,
											label: `Admin - ${subItem?.label}`,
										}))
									: {
											value: item?.key || item?.label,
											label: item?.isAdmin
												? `Admin - ${item?.label}`
												: item?.label,
										},
							)}
						showSearch
						onChange={(value) => {
							navigate(value?.value);
							setCollapsed(true);
						}}
					/>
				</div>
			)}
			<Menu
				className={` ${styles['side']} ${
					collapsed === true
						? styles['sidebar-collapsed']
						: userType === 'sm'
							? styles['sidebar-sm']
							: styles['sidebar']
				}`}
				mode="inline"
				openKeys={openKeys}
				inlineCollapsed={collapsed}
				items={menuItems}
				triggerSubMenuAction="click"
				onClick={onClick}
				onOpenChange={onOpenChange}
				selectedKeys={[window.location.pathname]}
			/>
		</div>
	);
};

export default Sidebar;
